import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISlotList } from '../../../Pages/Slot/ISlot';

export const AddSpaceSlicer = createSlice({
  name: 'AddSpace',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISlotList>,
  reducers: {
    addSpace: (state, _) => {
      state.isLoading = true;
    },
    successAddSpace: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddSpace: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddSpaceState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addSpace,
  failureAddSpace,
  successAddSpace,
  clearAddSpaceState,
} = AddSpaceSlicer.actions;

export default AddSpaceSlicer.reducer;
